import { translate } from '@web-platform/shared-universal-translations';

export const getHotelReviewRatingTranslation = (score: number): string => {
  if (score === 5) {
    return translate('recommendations_hotel_rating_with_honours');
  }
  if (score >= 4.5) {
    return translate('recommendations_hotel_rating_excellent');
  }
  if (score >= 4) {
    return translate('recommendations_hotel_rating_very_good');
  }
  if (score >= 3.5) {
    return translate('recommendations_hotel_rating_good');
  }
  if (score >= 3) {
    return translate('recommendations_hotel_rating_satisfactory');
  }
  if (score >= 2.5) {
    return translate('recommendations_hotel_rating_average');
  }
  return translate('recommendations_hotel_rating_below_average');
};
